var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 666.7 666.7",
    style: {
      enableBackground: "new 0 0 666.7 666.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#2159D1;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,333.3C0,149.2,149.2,0,333.3,0c184.1,0,333.3,149.2,333.3,333.3c0,184.1-149.2,333.3-333.3,333.3 C149.2,666.7,0,517.4,0,333.3z M456.9,243.1c13,13,13,34.1,0,47.1L334.1,413c-18.9,18.9-49.4,18.9-68.3,0l-56.1-56.1 c-13-13-13-34.1,0-47.1c13-13,34.1-13,47.1,0l43.1,43.1l109.8-109.8C422.8,230.1,443.9,230.1,456.9,243.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon2);
export default __webpack_public_path__ + "static/media/check_icon_2.d8048c56401149647cdab380152b1f3b.svg";
export { ForwardRef as ReactComponent };